import Echo from "laravel-echo";
// import Pusher from 'pusher-js';
const environmentString = (param: string | undefined) => {
  if (typeof param === "string") {
    return param;
  } else {
    console.error("ошибка переменного окружения !!!!!" + param);
    return "";
  }
};
require("pusher-js");
const protocol = environmentString(process.env.REACT_APP_API_WSS_POTOCOL);
const hostName = environmentString(process.env.REACT_APP_API_WSS_URL);
const hostPort = "";
const wsPort = environmentString(process.env.REACT_APP_API_WSS_PORT);
// hostPort - laravel port
// wsPort   - websocket port
// hostName - domain name
// protocol - protocol use(ssl or without)
// echoi    - class object for connection to channels laravel websocket

// const hostName = '194.61.0.136';
// const hostPort = ':86';
// const hostPort = ':4444';
// const hostPort = ':9999';

// https://devsimback.team-itonline.ru/broadcasting/auth
// https://devsimback.team-itonline.ru/broadcasting/auth
// https://devsimback.team-itonline.ru/broadcasting/auth
// const protocol = "http://";
// const hostName = "localhost";
// const hostPort = ":8002";
// const wsPort = "6002";
export class Echoi extends Echo {
  private echoi: Echo = this;
  constructor() {
    const token = localStorage.getItem("access_token");
    const options = {
      broadcaster: "pusher",
      key: "gosWebSocketkey",
      cluster: "mt1",
      wsHost: hostName,
      forceTLS: true,
      wssPort: wsPort,
      disableStats: true,
      authEndpoint: protocol + hostName + hostPort + "/broadcasting/auth",
      authHost: protocol + hostName + hostPort,
      auth: {
        headers: {
          Accept: "application/json",
          Authorization: "Bearer " + token,
        },
      },
    };
    super(options);
    this.init();
    this._getWss();
  }

  private init() {
    this.echoi = this;
    this.echoi.connector.pusher.connection.bind("connected", () => {
      this.echoi?.socketId();
    });
  }

  _getWss() {
    return this.echoi;
  }
}

// public testConnection(user_id: number) {
//   // const token = "3|YKoLGRQcFlr9Rrb96sgT0DTl0rlRBbxC99RbhtM7";
//   // const token = "4|Wqu4opuDTHXyCYYWVeY6qtbEKvXqo2mICM9BevK1";
//   const echoi = this.getEchoi();
//   // echoi.options.auth.headers.Authorization = "Bearer " + token;

//   echoi
//     .private("user." + user_id)
//     .listen("PrivateUserMessageEvent", (res: any) => {

//       notification.info({
//         message: res.data.message.text,
//         description: "От " + res.data.user.name,
//         placement: "bottomRight",
//       });
//     })
//     .error((err: any) => {
//       console.log("err", err);
//       if (err.type === "AuthError") {
//         alert("Уведомления перестали работать.\nПерезагрузите страницу");
//       }
//     })
//     .subscribed(() => {
//       console.log("PrivateUserMessageEvent - ПОДПИСАН");
//     });
//   this.echoi = echoi;
//   return this.echoi;
// }
